import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

// Good
const get = function ($, params = {}, StaffId = null) {
  return new Promise((resolve, reject) => {
    // HTTP.get(`/business/${StaffId ? "voucher/" + StaffId : "" + "voucher"}`)
    const url = `/business/${StaffId ? "voucher/" + StaffId : "" + "voucher"}`;
    HTTP.get(url, { params }) 
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const getHistory = function ($, params = {}, StaffId = null) {
  return new Promise((resolve, reject) => {
    const url = `/business/voucher/${StaffId}/history`;
    HTTP.get(url, { params }) 
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}


const getClients = function ($, params = {}) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/business/voucher/client`, { params })
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const create = function ($, cfsi) {
  return new Promise((resolve, reject) => {
    HTTP.post(`business/voucher`, cfsi)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const regularize = function ($) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/business/voucher/run-purchase-voucher-cron`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const update = function ($, cfsiId, data) {
  return new Promise((resolve, reject) => {
    HTTP.patch(`/business/voucher/${cfsiId}`, data)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const remove = function ($, cfsiId) {
  return new Promise((resolve, reject) => {
    HTTP.delete(`/business/voucher/${cfsiId}`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const close = function ($, cfsiId) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/business/voucher/${cfsiId}/close`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const approve = function ($, voucherId, payload = { approve: true }) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/business/voucher/${voucherId}/approve`, payload)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

// Ajoutez cette méthode dans CompanyVouchersService
const exceptionalIncrease = function ($, voucherId, data) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/business/voucher/${voucherId}/exceptional-increase`, data)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const deactivate = function ($, id) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/business/voucher/${id}/deactivate`)
      .then(response => resolve(response.data))
      .catch(err => reject(err))
  })
}



export default {
  get,
  getClients,
  create,
  update,
  remove,
  regularize,
  close,
  getHistory,
  approve,
  exceptionalIncrease,
  deactivate
}
